import {ValueObject} from '@s-ui/domain'

export class GetVehicleConfiguratorSeoDataRequest extends ValueObject {
  #makeName
  #makeSlug
  #modelName
  #modelSlug

  constructor({makeName, makeSlug, modelName, modelSlug}) {
    super()
    this.#makeName = makeName
    this.#makeSlug = makeSlug
    this.#modelName = modelName
    this.#modelSlug = modelSlug
  }

  static create({makeName, makeSlug, modelName, modelSlug}) {
    return new GetVehicleConfiguratorSeoDataRequest({makeName, makeSlug, modelName, modelSlug})
  }

  get makeName() {
    return this.#makeName
  }

  get makeSlug() {
    return this.#makeSlug
  }

  get modelName() {
    return this.#modelName
  }

  get modelSlug() {
    return this.#modelSlug
  }

  get value() {
    return {
      makeName: this.#makeName,
      makeSlug: this.#makeSlug,
      modelName: this.#modelName,
      modelSlug: this.#modelSlug
    }
  }
}
